<template>
    <div style="width: 100%; padding: 10px;">
        <h5>LOAD DELIVERIES</h5>

        <b-modal id="modal-ds-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
            <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
        </b-modal>

        <div
          v-if="isMobile"
          class="d-flex justify-content-between align-items-center mb-2 py-2"
        >
          <b-button
            size="sm"
            variant="outline-primary"
            @click="filtersVisible = !filtersVisible"
          >
            <b-icon-funnel-fill class="mr-1" />
            {{ filtersVisible ? "Hide Filters" : "Show Filters" }}
          </b-button>
        </div>

        <b-collapse :visible="!isMobile || filtersVisible" style="width: 100%;">
            <b-alert variant="secondary" show style="width: 100%;">
                <div style="display: block;">
                    <div style="display: inline-block; vertical-align: top;">
                        <div>SELECT YEAR</div>

                        <b-form-select size="lg" :options="years" v-model="year" style="width: 180px; font-size: 17px; font-weight: bold;" v-on:change="month=null; picked_date=null; filter_on_truck=null; items=[];">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- YEAR --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div style="display: inline-block; vertical-align: top;" v-if="year">
                        <div>SELECT MONTH</div>

                        <b-form-select size="lg" :options="months" v-model="month" style="width: 180px; font-size: 17px; font-weight: bold;" v-on:change="get_delivery_dates_for_year_month">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- MONTH --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div style="display: inline-block; vertical-align: top;" v-if="year && month">
                        <div>SELECT DATE</div>

                        <b-form-select size="lg" :options="dates" v-model="picked_date" style="width: 180px; font-size: 17px; font-weight: bold;" v-on:change="get_delivery_items_for_date">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- DATE --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>


                    <div style="display: inline-block; vertical-align: top;" v-if="items.length >0">
                        <div>FILTER DLVRY TRUCK</div>

                        <b-form-select size="lg" :options="packet.trucks" v-model="picked_truck" style="width: 180px; font-size: 17px; font-weight: bold;">
                            <template #first>
                                <b-form-select-option :value="null">ALL</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div style="display: inline-block; vertical-align: top;" v-if="items.length >0">
                        <div>FILTER SOLD LOC</div>

                        <b-form-select size="lg" :options="filter_locations(packet.locations)" v-model="picked_location_id" style="width: 180px; font-size: 17px; font-weight: bold;">
                            <!-- <template #first>
                                <b-form-select-option :value="null">ALL</b-form-select-option>
                            </template> -->
                        </b-form-select>
                    </div>
                </div>
            </b-alert>
        </b-collapse>

            <div style="width: 100%;">

                <div v-if="items_being_loaded == true">
                    <loading
                    :active="true"
                    :can-cancel="false"
                    :is-full-page="true">
                    </loading>
                </div>

                <div v-else-if="items_being_loaded == false">
                    <div v-if="items.length > 0" class="diver">
                        <b-alert show variant="transparent" style="background: #e0e7ed;" v-for="item,idx in items" v-bind:key="idx" v-if="allowed_invoice_truck(item) && allowed_invoice_location(item)">

                            <table style="width: 100%">
                                <thead>
                                    <tr>
                                        <th class="srr" style="min-width: 100px;" @click="sortby('rank_number')">RANK</th>
                                        <th class="srr" style="min-width: 150px;" @click="sortby('invoice_id')">INVOICE #</th>
                                        <th class="srr" style="min-width: 70px;" @click="sortby('cubes')">CUBES</th>
                                        <th class="srr" style="min-width: 150px;" @click="sortby('fullname')">CUSTOMER</th>
                                        <th class="srr" style="min-width: 250px;" @click="sortby('address')">ADDRESS</th>
                                        <th class="srr" style="min-width: 100px;" @click="sortby('zipcode')">ZIPCODE</th>
                                        <th class="srr" style="min-width: 140px;" @click="sortby('city')">CITY</th>
                                        <th class="srr" style="min-width: 140px;" @click="sortby('state')">STATE</th>
                                        <th class="srr" style="min-width: 140px;" @click="sortby('phone')">PHONE</th>
                                        <th class="srr" style="min-width: 80px;">LOADED</th>
                                        <th class="srr" style="min-width: 80px;">ACTION</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td class="srrv">{{ item.rank_number }}</td>
                                        <td class="srrv" :style="{ color: find_nloaded(item.items)==item.items.length ? 'green' : 'black' }">
                                            {{ item.invoice_id }}
                                        </td>
                                        <td class="srrv">{{ item.cubes }}</td>
                                        <td class="srrv">{{ item.fullname.toUpperCase() }}</td>
                                        <td class="srrv">{{ item.address.toUpperCase() }}</td>
                                        <td class="srrv">{{ item.zipcode.toUpperCase() }}</td>
                                        <td class="srrv">{{ item.city.toUpperCase() }}</td>
                                        <td class="srrv">{{ item.state.toUpperCase() }}</td>
                                        <td class="srrv">{{ item.phone.toUpperCase() }}</td>

                                        <td class="srrv">
                                            {{ find_nloaded(item.items) }} / {{ item.items.length }}
                                        </td>

                                        <td class="srrv">
                                            <b-button size="sm" @click="item.show_detail = !item.show_detail">ITEMS</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div v-if="item.show_detail" style="margin-top: 5px;">
                                <table style="width:100%; background:#fffce7; font-size:13px;">
                                    <thead>
                                        <tr>
                                            <th class="srr" style="min-width: 50px;">GROUP</th>
                                            <th class="srr" style="min-width: 100px;">PRODUCT SKU</th>
                                            <th class="srr" style="min-width: 150px;">PRODUCT NAME</th>
                                            <th class="srr" style="min-width: 30px;">QTY</th>
                                            <th class="srr" style="min-width: 150px;">ORIG LOC</th>
                                            <th class="srr" style="min-width: 150px;">CURRENT LOC</th>
                                            <th class="srr" style="min-width: 150px;">STAGING</th>
                                            <th class="srr" style="min-width: 160px;">LOAD FROM</th>
                                            <th class="srr" style="min-width: 80px;">TRUCK</th>
                                            <th class="srr" style="min-width: 100px;">TYPE</th>
                                            <th class="srr" style="min-width: 200px;">STATUS</th>
                                            <th class="srr" style="min-width: 80px;">ACTION</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="element in item.items" v-if="allowed_element(element)">
                                            <td class="srrv2">{{ element.parent_product_sku }}</td>
                                            <td class="srrv2">{{ element.product_sku }}</td>
                                            <td class="srrv2">{{ element.product_name }}</td>
                                            <td class="srrv2">{{ element.quantity }}</td>

                                            <td class="srrv2">{{ packet.locsubsdict[element.original_locsub] }}</td>
                                            <td class="srrv2">{{ packet.locsubsdict[element.locsub] }}</td>
                                            <td class="srrv2">{{ packet.locsubsdict[element.ship_locsub] }}</td>
                                            <td class="srrv2">{{ packet.locsubsdict[element.drop_locsub] }}</td>

                                            <td class="srrv2">{{ packet.trucksdict[element.truck] }}</td>

                                            <td class="srrv2">
                                                <span v-if="element.is_special" style="background:pink;"><b>SPECIAL</b></span>
                                                <span v-else><b>REGULAR</b></span>
                                            </td>

                                            <td class="srrv2">
                                                <b-form-select
                                                    :options="states"
                                                    v-model="element.state"
                                                    size="sm"
                                                    @change="update_n_delivered(item, element)"
                                                    :disabled="element.quantity == 0"
                                                ></b-form-select>
                                            </td>

                                            <td class="srrv2">
                                                <b-button size="sm" @click="show_comments(element)">CMNT</b-button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </b-alert>
                    </div>
                </div>

                <div v-else>

                </div>
            </div>
        </div>

</template>

<script>
    import moment from 'moment';
    import mappings from '@/utilities/mappings'

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import draggable from 'vuedraggable';
    import { BIconFunnelFill } from "bootstrap-vue";

    import ItemComments from '@/components/importables/ItemComments';

    export default {
        name: "DeliveriesLoading2",
        components: {flatPickr, Loading, ItemComments,draggable},
        data: function(){
            let out = {
                dates: [],
                items: [],
                packet: {},
                truck_dates_being_loaded: false,
                items_being_loaded: false,
                date: null,
                truck: null,
                trucks: [],
                locations: [],
                item_comments_invoice_id: null,
                item_comments_itemid: null,

                delivery_ranks: [],
                delivery_rank_map: {},
                colors_dict: {},
                states: mappings.states.map(function(d){ if ([6,-6].includes(d.value)){ d.disabled=false} else {d.disabled=true}; return d }),
                states_dict: mappings.states_dict,
                merchandise_statuses_dict: mappings.merchandise_statuses_dict,
                ranks: [],
                sort_asc: false,

                years: [
                    {value: 2022, text: 2022},
                    {value: 2023, text: 2023},
                    {value: 2024, text: 2024},
                    {value: 2025, text: 2025},
                    {value: 2026, text: 2026},
                    {value: 2027, text: 2027},
                    {value: 2028, text: 2028},
                    {value: 2029, text: 2029},
                    {value: 2030, text: 2030},
                    {value: 2031, text: 2031},
                    {value: 2032, text: 2032},
                    {value: 2033, text: 2033},
                    {value: 2034, text: 2034},
                    {value: 2035, text: 2035},
                ],
                months: [
                    {value: 1, text: 1},
                    {value: 2, text: 2},
                    {value: 3, text: 3},
                    {value: 4, text: 4},
                    {value: 5, text: 5},
                    {value: 6, text: 6},
                    {value: 7, text: 7},
                    {value: 8, text: 8},
                    {value: 9, text: 9},
                    {value: 10, text: 10},
                    {value: 11, text: 11},
                    {value: 12, text: 12},
                ],
                year: null,
                month: null,
                picked_date: null,
                picked_location_id: null,
                picked_truck: null,
                filtersVisible: true,
                isMobile: false,
            }
            return out
        },
        methods: {
            handleResize() {
                this.isMobile = window.innerWidth < 768;
            },
            find_nloaded: function(items){
                return items.filter(function(d){return d.state == 6}).length
            },
            allowed_element: function(element){
                let status = true;
                if (element.locsub) {
        const [locationId] = element.locsub.toString().split('|');
        if (parseInt(locationId) === 46) {
            return false; // Hide items with location 46 (out of stock)
        }
    }
                if (this.picked_truck){
                    if (element.truck != this.picked_truck){
                        status = false
                    }
                    else {
                        status = true
                    }
                }
                else {
                    status = true
                }

                return status
            },

            allowed_invoice_truck: function(item){
                let status = true;
                let that = this;
                if (this.picked_truck){
                    let n = item.items.filter(function(d){return d.truck == that.picked_truck}).length;
                    let m = item.items.length;

                    if (n == 0){
                        status = false
                    }
                    else {
                        status = true
                    }
                }
                else {
                    status = true;
                }
                return status
            },
            allowed_invoice_location: function(item){
                let status = true;
                if (this.picked_location_id){
                    if (item.location_id != this.picked_location_id){
                        status = false
                    }
                    else {
                        status = true
                    }
                }

                return status
            },
            update_n_delivered: function(item, ditem){
                item.n_delivered = item.items.filter(function(d){return d.state == 1}).length;
                this.update_invoice_item_state(item, ditem);
            },
            sort_and_save: function(key, mapper){
                this.sortby(key,mapper);

                // if (!this.picked_truck){
                //     this.$bvToast.toast(
                //         "PLEASE SELECT A TRUCK AND THEN THE RANKS WILL BE ASSIGNED",
                //         {title: "NOT SAVED", autoHideDelay: 1500, variant:"warning"}
                //     );
                //     return
                // }

                // //now assign new delivery ranks based on this order and save to db;
                // let ranks = [];
                // for (var i=0; i<this.items.length; i++){

                //     ranks.push(
                //         {invoice_id: this.items[i].invoice_id, delivery_date: this.picked_date, rank_number: i+1}
                //     )
                //     this.items[i].rank_number = i+1;

                // }
                // let data = {ranks: ranks}
                // let s = function(response) {
                //     if (response.data.error){
                //         that.$bvToast.toast(
                //             response.data.error,
                //             {title: "Error", autoHideDelay: 1500, variant:"warning"}
                //         );
                //     }
                //     that.items_being_loaded = false;
                // }

                // let f = function(error) {
                //     that.$bvToast.toast(
                //         "Error assigning invoice ranks.",
                //         {title: "Error", autoHideDelay: 1500, variant:"danger"}
                //     );
                //     that.items_being_loaded= false;
                // }
                // item.items_being_loaded = true;
                // Requestor.postAsyncP(path, data, this, s, f);

            },



            fetch_delivery_items_for_invoice_date: function(item){
                let invoice_id = item.invoice_id;
                let date = item.delivery_date;
                let path = "/api/sales/fetch_delivery_items_for_invoice_date/"
                let that = this;
                let data = {invoice_id: invoice_id, date: date};
                let s = function(response) {
                    if (response.data.result){
                        item.delivery_items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    item.loading_delivery_items = false;
                }

                let f = function(error) {
                    that.$bvToast.toast(
                        "Error retrieving delivery items for the invoice.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.loading_delivery_items= false;
                }
                item.loading_delivery_items = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            get_delivery_dates_for_year_month: function(){
                let path = "/api/sales/get_delivery_dates_for_year_month/"
                let that = this;
                let data = {year: this.year, month: this.month, merchandise_status: [2]};
                let s = function(response) {
                    if (response.data.result){
                        that.dates = response.data.result;

                        that.dates = that.dates.map(function(d){
                            return {value: d.date, text: d.date + ' ('+d.n_invoices+')' }
                        });
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.dates_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error retrieving dates for the loading items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.dates_being_loaded = false;
                }

                this.items = []
                this.dates_being_loaded = true;
                this.picked_date = null;
                this.picked_location_id = null;
                Requestor.postSyncP(path, data, this, s, f);
            },
            get_delivery_items_for_date: function() {
                let path = "/api/sales/get_delivery_items_for_date/"
                let that = this;
                let data = {date: this.picked_date, merchandise_status: [1]};
                if (this.packet.userDetails.userrole == 'truck'){
                    data.truck = this.packet.userDetails.userrole;
                }
                let s = function(response) {
                    if (response.data.result){
                        //console.log(response.data.result)
                        that.items = response.data.result;
                        that.delivery_ranks = that.items.map(function(d,i){ return {text: i+1, value: i+1}});
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading items to be delivered for the date.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items = [];
                this.picked_truck = null;
                this.delivery_ranks = [];
                this.picked_location_id = null;
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            get_all_done_deliveries: function(){
                let that = this;
                let statuses = this.items.map(function(d){return that.is_delivered_all(d)});

                return statuses.filter(function(d){return d == true}).length;
            },
            is_delivered_all: function(item){
                let status = false;
                let that = this;
                let l = item.items.filter(function(d){
                    return (parseInt(d.state) == -8 || parseInt(d.state) == 1)
                });

                if (l.length == item.items.length){
                    status = true
                }
                return status
            },
            log: function(e){
                /*
                    if new_index > old_index
                        -- moved down
                        -- find out element with new_index
                            and assign it value of new_index - 1
                    if new_index < old_index:
                        -- moved up
                        -- find out element with new_index
                            and assign it value new_index + 1

                */
                let that = this;
                let invoice_id = e.moved.element.invoice_id;
                let new_index = e.moved.newIndex;
                let old_index = e.moved.oldIndex;

                let key = this.date + invoice_id + this.packet.userDetails.id;

                let old_key = null
                if (new_index > old_index){
                    // moved down
                   old_key = Object.keys(this.delivery_rank_map).filter(function(d){
                        return that.delivery_rank_map[d] == new_index;
                    });

                    if (old_key.length > 0){
                        this.delivery_rank_map[old_key[0]] = Math.max(0, new_index-1);
                    }
                }
                else {
                    old_key = Object.keys(this.delivery_rank_map).filter(function(d){
                        return that.delivery_rank_map[d] == new_index;
                    });

                    if (old_key.length > 0){
                        this.delivery_rank_map[old_key[0]] = Math.min(this.items.length-1, new_index+1);
                    }
                }

                this.delivery_rank_map[key] = new_index;
                console.log(this.delivery_rank_map);
                this.save_delivery_rank_map()
            },
            save_delivery_rank_map: function(){
                localStorage.setItem("delivery_rank_map", JSON.stringify(this.delivery_rank_map));
                console.log(this.get_delivery_rank_map())
            },
            get_delivery_rank_map: function(){
                let delivery_rank_map = {}
                try{

                    delivery_rank_map =  JSON.parse(localStorage.delivery_rank_map);
                } catch(e) {

                }
                return delivery_rank_map
            },
            get_bg: function(item){
                let all_items = item.items.length;
                let all_delivered = item.items.filter(function(d){
                    return d.state == 'delivered'
                }).length;

                if (all_items ==  all_delivered){
                    return '#aed581'
                }
                else {
                    return '#fff176'
                }
            },
            toggle_details: function(item){
                item.show_details = (!item.show_details)
            },
            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid= item.itemid;
                this.$bvModal.show("modal-ds-comments");
            },
            update_delivery_rank: function(item){
                let path = "/api/sales/update_delivery_rank/"
                let that = this;

                let data = {invoice_id: item.invoice_id, delivery_date: this.picked_date, rank_number: item.rank_number}

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {

                        that.$bvToast.toast(
                            "Success updating delivery rank for invoice.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );

                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating delivery rank for invoice.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsync(path, data, s, f);
            },
            update_invoice_item_state: function(item, element){
                let path = "/api/sales/update_invoice_item_state/"
                let that = this;

                let data = {invoice_id: element.invoice_id, itemid: element.itemid, state: element.state, changed_by: this.packet.userDetails.username, product_sku: element.product_sku, quantity: element.quantity}

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        //item = response.data.result[0];
                        //element.state = element.state;

                        // item.unprocessed = item.items.filter(function(d){return !d.state }).length
                        // item.processed = item.items.filter(function(d){return (d.state != null && d.state != 'cannot_be_pulled') }).length
                        // item.failed = item.items.filter(function(d){return d.state == 'cannot_be_pulled' }).length

                        that.$bvToast.toast(
                            "Success updating item state.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        ///that.update_colors_dict();
                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating item state.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsync(path, data, s, f);
            },
            get_truck_dates: function(truck){
                let data = {"truck": this.truck}
                let that = this;
                let path = "/api/sales/get_truck_dates/"
                let s = function(response) {
                    if (response.data.result){
                        that.dates = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.truck_dates_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error fetching dates for the truck.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.truck_dates_being_loaded = false;
                }
                this.dates = []
                this.date = null
                this.items = []
                this.truck_dates_being_loaded = true;
                Requestor.getSync(path, data, s, f);
            },
            update_colors_dict: function(){
                for (var i =0; i<this.items.length; i++){
                    let invoice_id = this.items[i].invoice_id;
                    for (var j=0; j<this.items[i].items.length; j++){
                        let itemid = this.items[i].items[j].itemid;
                        let state = this.items[i].items[j].state;

                        let color = 'white';
                        if (state == 1){
                            color = '#c5e1a5'
                        }
                        if (state == -7 || state == -8){
                            color = '#b0bec5'
                        }

                        let key = invoice_id+itemid;
                        this.colors_dict[key] = color;
                    }
                }
            },
            sortby: function(key,mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key, mapper)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key, mapper)
                }
                this.sort_asc = !this.sort_asc;
            },
            fetch_prereqs: function(){
            },
            filter_locations: function(locations) {
                let userrole = this.packet.userDetails.userrole;
                let userLocationId = this.packet.userDetails.properties.location_id;

                if (userrole == 'admin' || userrole == 'officeuser') {
                    return locations.filter(d => ![44,46].includes(d.value));
                }
                else {
                    // For non-admin users, filter locations to show only their assigned location
                    if (userLocationId) {
                        return locations.filter(function(d) {
                            return d.value == userLocationId;
                        });
                    } else {
                        // If no location is assigned, show main warehouse only
                        return locations.filter(function(d) {
                            return d.is_main_warehouse == true;
                        });
                    }
                }
            },

        },
        mounted: function() {
            this.handleResize();
            window.addEventListener("resize", this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.handleResize);
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            let that = this;
        }
    }

</script>

<style scoped>
    .diver {
        overflow: auto;
        width: 100%;
        height: 800px;
    }
    .ipt_tdr {
        font-family: roboto !important;
        font-size: 13px;
        background: white;
    }

    .pcol {
        padding: 5px;
    }

    .card-body {
        padding: 5px;
    }

    .diff {
        font-family: monospace;
        font-size: 14px;
    }

    .inv_header_class {
        border: 1px solid black;
        color: white;
        background: black;
        text-align: center;
    }

    .inv_header_class2 {
        border: 1px solid black;
        color: black;
        background: #cfd8dc;
        text-align: center;
        font-size: 13px;
        padding: 0px;
    }

    .inv_content_class {
        border: 1px solid black;
        color: black;
        background: white;
        text-align: center;
    }

    .inv_content_class2 {
        border: 1px solid black;
        color: black;
        background: white;
        text-align: center;
        font-size: 13px;
        padding: 0px;
        background: lightyellow;

    }

    .srr {
        font-size: 11px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
        background-color: #e1f5fe;
    }

    .srrv2 {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
        background-color: #fffce7;
    }

    @media (max-width: 768px) {
        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/IncomingOutGoing/DeliveriesLoading2.vue